(function(window, $) {
    /////// TEXT TOGGLER
    $(document).on('click', '[data-toggle-trigger]', function(){
        $(this).find('[data-toggle-label]').toggle();
    });
    /////// TEXT TOGGLER

    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
    
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
    
            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };
    var loadMore = jQuery("#AjaxinatePagination .pagination .btn");
    var totalPaginate = jQuery(".items-passed").attr("data-total-count");
    var paginating = jQuery(".items-passed").attr("data-paginate-count");

    $(document).on('click', loadMore, function(){
        window.setTimeout(function(){
            var i = getUrlParameter('i');
            if(typeof i != undefined && i != 0) {
                var itemPaginate = paginating * i;
                if(itemPaginate > totalPaginate) {
                    var itemPassed = totalPaginate;
                } else {
                    var  itemPassed = itemPaginate;
                }
                $(".items-passed").text(itemPassed);
            }
        }, 2000);
    });

    $(document).ready(function(){
        window.setTimeout(function(){
            var i = getUrlParameter('i');
            if(typeof i != undefined && i != 0) {
                var itemPaginate = paginating * i;
                if(itemPaginate > totalPaginate) {
                    var itemPassed = totalPaginate;
                } else {
                    var  itemPassed = itemPaginate;
                }
                $(".items-passed").text(itemPassed);
            }
        }, 2000);
        
        $('.load-descr-trigger').on('click', function(e){
            var parentLoadDescr = $(e.target).closest('div');                    
            parentLoadDescr.toggleClass('show');
       });
    });
            
})(window, jQuery);
